module.exports = __webpack_public_path__ + "static/review_model-52b941d8bf1302e3724b5bc381b9a853.svg";